import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import CampaignForm from "../../components/Campaign/CampaignForm";
import CampaignProducts from "../../components/Campaign/CampaignProducts";

import { useCampaign } from "../../features/capmpaign/useCampaigns";
import useCampaignStore from "../../store/campaignStore";

const CampaignFormPage = () => {
  const navigate = useNavigate();
  const { slug } = useParams();

  const isEditMode = Boolean(slug) && slug !== "new";

  const {
    data: campaign,
    isLoading,
    isError,
  } = useCampaign(isEditMode ? slug : null);

  const resetCampaignDraft = useCampaignStore(
    (state) => state.resetCampaignDraft
  );

  useEffect(() => {
    return () => {
      resetCampaignDraft();
    };
  }, [resetCampaignDraft]);

  const handleSuccess = (savedCampaign) => {
    const nextSlug = savedCampaign?.slug || campaign?.slug;

    if (nextSlug) {
      navigate(`/admin-panel/campaigns/${nextSlug}/edit`, { replace: true });
      return;
    }

    navigate("/admin-panel/campaigns", { replace: true });
  };

  if (isEditMode && isLoading) {
    return (
      <main dir="rtl" className="min-h-screen bg-white p-4 sm:p-6 lg:p-10">
        <div className="mx-auto max-w-6xl">
          <div className="rounded-2xl border border-gray-200 bg-white p-10 text-center text-sm text-gray-500 shadow-sm">
            در حال دریافت اطلاعات رویداد...
          </div>
        </div>
      </main>
    );
  }

  if (isEditMode && isError) {
    return (
      <main dir="rtl" className="min-h-screen bg-white p-4 sm:p-6 lg:p-10">
        <div className="mx-auto max-w-6xl">
          <div className="rounded-2xl border border-red-200 bg-red-50 p-10 text-center text-sm text-red-700 shadow-sm">
            اطلاعات رویداد دریافت نشد.
          </div>
        </div>
      </main>
    );
  }

  return (
    <main dir="rtl" className="min-h-screen bg-white p-4 sm:p-6 lg:p-10">
      <div className="mx-auto max-w-6xl">
        <h1 className="mb-6 text-xl font-semibold text-gray-900 sm:text-2xl">
          {isEditMode ? "ویرایش رویداد" : "فرم رویداد"}
        </h1>

        <div className="space-y-6">
          <CampaignForm
            campaign={isEditMode ? campaign : null}
            onSuccess={handleSuccess}
            onCancel={() => navigate("/admin-panel/campaigns")}
          />

          {isEditMode && campaign?.slug && (
            <CampaignProducts
              slug={campaign.slug}
              products={campaign.products || []}
            />
          )}
        </div>
      </div>
    </main>
  );
};

export default CampaignFormPage;
